import { combineReducers } from 'redux'
import sliceReducer from '../reducers/sliceReducer'
import userReducer from '../reducers/userReducer'
import t4aReducer from '../reducers/t4aReducer'
import driverReducer from '../reducers/driverReducer'
import driverUSReducer from '../reducers/driverUSReducer'

const rootReducer = combineReducers({
  ui: sliceReducer,
  user: userReducer,
  t4a: t4aReducer,
  driverReducer: driverReducer,
  driverUSReducer: driverUSReducer
})

export default rootReducer
